// extracted by mini-css-extract-plugin
export default {"Virtual":"Virtual_Virtual__UeQPg","left":"Virtual_left__YNhsQ","wrapper":"Virtual_wrapper__YSoSV"};